import { Meta, StoryObj } from '@storybook/react';

import { ButtonLink } from './ButtonLink';

const meta: Meta<typeof ButtonLink> = {
  title: 'parts/link button/ButtonLink',
  component: ButtonLink,
  args: {
    text: 'link button',
    href: '#',
    target: '_blank',
    rel: 'noreferrer',
    addClass: [],
  },
};

export default meta;

type Story = StoryObj<typeof ButtonLink>;

export const Basic: Story = {
  render: args => <ButtonLink {...args} />,
};
